var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz-preview-wrapper" }, [
    _c("div", { staticClass: "preview-header" }),
    _vm._v(" "),
    _c("div", { staticClass: "preview-body" }, [
      _c("div", { staticClass: "preview-quiz-wrapper" }, [
        _vm.getQuizTags(_vm.quiz)
          ? _c(
              "div",
              { staticClass: "tag-wrapper" },
              _vm._l(_vm.getQuizTags(_vm.quiz), function(value, index) {
                return _c("div", { key: index, staticClass: "tag" }, [
                  _vm._v("\n        " + _vm._s(value) + "\n      ")
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v("\n      " + _vm._s(_vm.quiz.content) + "\n    ")
        ]),
        _vm._v(" "),
        _vm.isNoOptionsQuiz(_vm.quiz.options)
          ? _c("div", { staticClass: "no-options-wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _c(
              "div",
              { staticClass: "options-wrapper" },
              _vm._l(_vm.quiz.options, function(option, index) {
                return _c("div", { key: index, staticClass: "option" }, [
                  _vm._v("\n        " + _vm._s(option.value) + "\n      ")
                ])
              }),
              0
            )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-footer" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option" }, [
      _c("img", { attrs: { src: "/static/images/ic-correct.svg" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "option" }, [
      _c("img", { attrs: { src: "/static/images/ic-incorrect.svg" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e372280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e372280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-quizzes/components/QuizPreview.vue
// module id = 8coR
// module chunks = 1